module.exports = __webpack_public_path__ + "./static/img/recently_added.8bf7c5b2ce9f5dd6666e852d0e82c8d1.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/recently_added.png
// module id = ./client/src/assets/fontawesome/recently_added.png
// module chunks = 0